<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512">
      <path class="color-background" fill="#3A416F" d="M528 224h-48V144C480 64.5 415.5 0 336 0S192 64.5 192 144v80H144c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V256c0-17.6-14.4-32-32-32zm-192 0H240V144C240 85.96 285.96 40 344 40s104 45.96 104 104v80z"/>
    </svg>
</template>
